export const Base = process.env.REACT_APP_API;
export const ApiKey = process.env.REACT_APP_BASE;
